module.exports = __webpack_public_path__ + "static/img/dl_youxiang.9d6cd7b8.png";